// extracted by mini-css-extract-plugin
export var defaultWrapper = "_k4-3";
export var downloadButton = "_k4-4";
export var fileContainer = "_k4-9 _k4-7";
export var fileContainerBase = "_k4-7";
export var fileContainerFixedHeight = "_k4-8 _k4-7";
export var fileInfo = "_k4-5";
export var fileInfoWidthRestricted = "_k4-6";
export var fileType = "_k4-1";
export var fileTypeName = "_k4-2";
export var image = "_k4-0";
export var link = "_k4-b";
export var overflowEllipsis = "_k4-a";